import React from 'react';
import { Row } from 'library/ui';
import { IProviderReviewOption } from 'models';
import ReviewOptionButton, { ReviewOptionTone } from 'parent-portal/provider-reviews/components/ReviewOptionButton';

export default function ReviewOptionSelect({
    options,
    value,
    onChange,
    isScorePositive,
    isScoreNeutral,
}: {
    options: IProviderReviewOption[];
    value: number[];
    onChange: (newVal: number[]) => void;
    isScorePositive?: boolean | 0;
    isScoreNeutral?: boolean | 0;
}) {
    const tone: ReviewOptionTone = isScoreNeutral ? 'neutral' : isScorePositive ? 'positive' : 'negative';

    const optionSelected = (option: IProviderReviewOption) => !!(value && value.includes(option.id));
    const onToggle = (option: IProviderReviewOption) => {
        onChange(optionSelected(option) ? value.filter((it) => it !== option.id) : [...value, option.id]);
    };

    return (
        <Row gap="sm" wrap>
            {options.map((option) => (
                <ReviewOptionButton
                    key={option.id}
                    selected={optionSelected(option)}
                    tone={tone}
                    onClick={() => onToggle(option)}
                >
                    {option.text}
                </ReviewOptionButton>
            ))}
        </Row>
    );
}
